import React from 'react';
import { PackageIcon, ArrowRightIcon } from 'lucide-react';
export const AddOnSection = () => {
  return <section className="py-24 md:py-32 bg-stone-50 relative z-10" data-id="element-26">
      <div className="container mx-auto px-6 md:px-12 max-w-5xl space-y-8" data-id="element-27">
        {/* Coming Soon Section */}
        

        {/* CTA Section */}
        <div className="bg-white rounded-xl md:rounded-2xl p-8 md:p-12 shadow-lg border border-stone-100" data-id="element-28">
          <div className="text-center" data-id="element-29">
            <div className="text-2xl md:text-3xl font-semibold text-[#186447] mb-8" data-id="element-30">
              Ready to expand your reach and grow your income?
            </div>
            <a href="https://calendly.com/kevin-certainly" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#186447] hover:bg-[#22AC79] text-white px-8 py-3 rounded-lg shadow-sm hover:shadow-md transition-all" data-id="element-31">
              Become a Glow-Up Coach
              <ArrowRightIcon size={20} strokeWidth={2} data-id="element-32" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};